import React, { Suspense, lazy } from 'react'
import './Title.css'

const CountUp = lazy(() => import('react-countup'));

const Title = ({desc, title, para, count}) => {
  return (
    <div className='main-title'>
        <div className='main-title-first'>{desc}</div>
        <div className='main-title-counter'>
          {
            count && (
              <span className="main-title-second">
                <Suspense fallback={<>+{count}</>}>
                  +<CountUp start={0} end={count} duration={2.5} />
                </Suspense>
              </span>
            )
          }
          <div className='main-title-second'>{title}</div>
        </div>
        <div className='main-title-para' dangerouslySetInnerHTML={{ __html: para }} ></div>
    </div>
  )
}

export default Title
